import { styled } from '@mui/material/styles';

export const StyledModalContent = styled('div')(
  ({ theme }) => `

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: ${theme.DS_spacing(['md'])};
    
    svg {
     fill: none;
     width: ${theme.DS_spacing(['xlx'])};
     height: ${theme.DS_spacing(['xlx'])};
     margin-bottom: ${theme.DS_spacing(['sm'])};
       ${theme.breakpoints.up('lg')} {
         margin-bottom: ${theme.DS_spacing(['md'])};
       }
    }
    

    
  `,
);
